import {
  IconUsers,
  IconHome2,
  IconUser,
  IconBuildingStore,
  IconShoppingBag,
  IconSettings,
  IconCoin,
} from '@tabler/icons-react';
import appConfig from '../config';

export const menuItems = [
  {
    id: 'dashbord',
    type: 'single',
    active: true,
    url: '/app/dashboard',
    icon: IconHome2,
    title: 'Dashboard',
    breadcrumbs: false,
  },
  {
    id: 'orders',
    type: 'single',
    active: true,
    url: '/app/orders',
    icon: IconShoppingBag,
    title: 'Orders',
    breadcrumbs: false,
  },
  {
    id: 'loans',
    type: 'single',
    active: true,
    url: '/app/loans',
    icon: IconCoin,
    title: 'Loans',
    breadcrumbs: false,
  },
  {
    id: 'users',
    type: 'single',
    active: true,
    url: appConfig.routes.usersPath,
    icon: IconUsers,
    title: 'Users',
    breadcrumbs: false,
  },
  {
    id: 'products',
    type: 'single',
    active: false,
    href: '/app/products',
    icon: IconBuildingStore,
    title: 'Products',
    breadcrumbs: false,
  },
  {
    id: 'account',
    type: 'single',
    active: false,
    href: '/app/account',
    icon: IconUser,
    title: 'Account',
    breadcrumbs: false,
  },
  {
    id: 'settings',
    type: 'single',
    active: false,
    href: '/app/settings',
    icon: IconSettings,
    title: 'Settings',
    breadcrumbs: false,
  },
];
